export default {
    SUMMIT_ENABLE:false,
    EDOTCO_ENABLE:true,
    CUSTOMER_SITE:'easi',
    APP_KEY:'base64:zFzih483S8geoMKMdndhsmjFsssJ/hoqroCNft+qc5o='
};